<div class="medium-content">
  <mat-card>
    <mat-card-content>
      <h1>Add users</h1>
      <p>Invite people to your organization</p>
      <form [formGroup]="form2" (ngSubmit)="addUser()">
        <div class="user-line">
          <div
            [ngClass]="spaceArray.length > 1 ? 'three-column' : 'two-column'"
            class="column-headers"
          >
            <div>Name</div>
            <div>Email</div>
            <div *ngIf="spaceArray.length > 1">Spaces</div>
          </div>
          <div></div>
        </div>

        <div formArrayName="users">
          <div
            [formGroupName]="i"
            *ngFor="
              let userControl of form2.controls.users.controls;
              let i = index;
              last as isLastUser
            "
          >
            <div class="user-line">
              <div
                [ngClass]="
                  spaceArray.length > 1 ? 'three-column' : 'two-column'
                "
              >
                <div>
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input
                      #nameElement
                      matInput
                      [formControl]="userControl.controls.name"
                      formControlName="name"
                    />
                    <mat-error
                      *ngIf="userControl.controls.name.hasError('required')"
                    >
                      Please enter a name
                    </mat-error>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input
                      matInput
                      [formControl]="userControl.controls.email"
                      formControlName="email"
                      placeholder="email@example.com"
                    />
                    <mat-error
                      *ngIf="
                        userControl.controls.email.hasError('email') &&
                        !userControl.controls.email.hasError('required')
                      "
                    >
                      Please enter a valid email address
                    </mat-error>
                    <mat-error
                      *ngIf="userControl.controls.email.hasError('required')"
                    >
                      Email is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="userControl.controls.spaces.controls.length > 1"
                  class="space-list"
                >
                  <div
                    *ngFor="
                      let space of userControl.controls.spaces.controls;
                      let j = index
                    "
                    formArrayName="spaces"
                  >
                    <mat-checkbox formControlName="{{ j }}">
                      {{ spaceArray[j].name }}
                    </mat-checkbox>
                  </div>
                  <mat-error *ngIf="userControl.controls.spaces.errors"
                    >Please select at least one space.
                  </mat-error>
                </div>
              </div>
              <div class="remove-button-container">
                <button
                  type="button"
                  mat-icon-button
                  aria-label="Remove user"
                  matTooltip="Remove user"
                  (click)="removeUser(i)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
            <mat-divider *ngIf="!isLastUser"></mat-divider>
          </div>
        </div>

        <div class="button-line">
          <div>
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="addUser()"
              [disabled]="waiting"
            >
              Add another user
            </button>
          </div>
          <div></div>
          <div>
            <mat-spinner *ngIf="waiting" diameter="24"></mat-spinner>
          </div>
          <div (click)="getUsersAndCheckErrors(true)">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="submitUsersToServer()"
              [disabled]="disableSubmit || waiting"
            >
              Finish adding users
            </button>
          </div>
        </div>
      </form>

      <div class="light-text-color">
        <p *ngIf="sub?.isActive">
          After adding these users we will immediately charge your card ({{
            sub?.creditCard?.last4
          }}) for the remainder of this billing period (until
          {{ sub?.productSubscription?.endAt }}), minus any credits you might
          have applied to your account.
        </p>

        Invites expire after a week. Make sure the people above promptly
        register for the service.
      </div>
    </mat-card-content>
  </mat-card>
</div>
